export const blockIconsAlertAddAlert = (
	<span className='material-symbols-outlined'>add_alert</span>
);
